import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import { Translate } from 'react-redux-i18n';

import CashFormatter from '../../Common/cashFormatter'
import { isOLG } from '../../../actions/root_url';

const IsVariableFormatter = React.createClass({
  render() {
    if (this.props.dependentValues.ProductType === 'Non-Fixed') {
      return <span>{this.props.value} <label className='label label-success'><Translate value="non_fixed" /></label></span>;
    } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
      return <span>{this.props.value} <label className='label label-primary'><Translate value="per_pound" /></label></span>;
    }
    return <span>{this.props.value}</span>;
  }
});

class SIPaymentFormTable extends Component {
  state = {
    rows: [],
    sortColumn: null,
    sortDirection: null,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows !== this.props.rows) {
      const { rows } = nextProps;
      this.setState({ rows });
    }
  }

  getRows = () => Data.Selectors.getRows(this.props);

  getSize = () => this.getRows().length;

  // Grid does not properly re-render when more than one row is updated at a time
  // Problem solved, for more info Refer to link:
  // https://github.com/adazzle/react-data-grid/issues/332
  rowGetter = (i) => JSON.parse(JSON.stringify(this.getRows()[i]));

  handleGridSort = (sortColumn, sortDirection) => {
    this.setState({
      rows: this.getRows(),
      sortColumn,
      sortDirection,
     });
  }

  render() {
    const columns = [
      {
          key: 'ProductNum',
          name: <Translate value="prod_num" />,
          resizable: true,
          sortable: true,
          width: 70
      },
      {
          key: 'RefNum',
          name: <Translate value={isOLG ? "item_no" : "ref_num"} />,
          resizable: true,
          sortable: true,
          width: 80
      },
      {
          key: 'Name',
          name: <Translate value="product_name" />,
          resizable: true,
          sortable: true,
          width: 200
      },
      {
          key: 'Description',
          name: <Translate value="description" />,
          resizable: true,
          sortable: true,
          width: 150
      },
      {
          key: 'LoadedQuantity',
          name: <Translate value="qty" />,
          resizable: true,
          sortable: true,
          width: 60,
          formatter: IsVariableFormatter,
          getRowMetaData: (row) => row
      },
      {
          key: 'NetWeight',
          name: <Translate value="net_wt" />,
          resizable: true,
          sortable: true,
          width: 60,
          filterable: true,
      },
      {
          key: 'PackageType',
          name: <Translate value="pkg_type" />,
          resizable: true,
          sortable: true,
          width: 80
      },
      {
          key: 'UnitPrice',
          name: <Translate value="unit_dollarsign" />,
          resizable: true,
          sortable: true,
          width: 70,
          formatter: CashFormatter,
      },
      {
        key: 'TotalPrice',
        name: <Translate value="total_dollarsign" />,
        width: 80,
        resizable: true,
        sortable: true,
        formatter: CashFormatter,
      },
      {
          key: 'TotalNetWeight',
          name: <Translate value="total_wt" />,
          width: 80,
          resizable: true,
          sortable: true,
          filterable: true,
      },
      {
          key: 'ItemNotation',
          name: <Translate value="notation" />,
          resizable: true,
          sortable: true,
          width: 150,
          filterable: true,
      },
    ];

    return (
        <div style={{ maxWidth: '100%' }} id="SIPaymentFormTable-dataGrid1">
          <ReactDataGrid
            rowKey='ProductNum'
            onGridSort={this.handleGridSort}
            columns={columns}
            rowHeight={25}
            headerRowHeight={45}
            minHeight={485}
            rowGetter={this.rowGetter}
            rowsCount={this.getSize()}
          />
        </div>
    );
  }
}

export default SIPaymentFormTable;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/SIPaymentForm/SIPaymentFormTable.jsx